
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import api from "~api";
export default {
name: "myNoticeApply",
components: {
XHeader,Group,Cell,XAddress,Datetime,Selector,XTextarea,XInput,XButton,Flexbox, FlexboxItem,XTable, LoadMore
},
data(){
return{
title: "转专业进度查询",
list: '',
}
},
mounted(){
this.getList();
},
methods:{
getList(){
const _this = this
let parms = {
"stuCode": window.localStorage.getItem("stuCode"),
"roleId":"1",
"runningId":""
}
api.post('/api/changeMajor/findDetail',parms).then(function (response) {
if(response.status===200){
if(response.data.findDetail!==null && response.data.findDetail.length>0){
_this.list = response.data.findDetail;
}else {
_this.$msgbox('温馨提示：',"暂无申请");
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
},
deleteItem(ite){
console.log(ite)
const _this = this
let parms = {
"runningId":ite
}
api.post('/api/changeMajor/delete',parms).then(function (response) {
console.log(response)
if(response.status===200){
if(response.data.code==='1'){
_this.$msgbox('温馨提示：',"删除成功");
_this.getList();
}else {
_this.$msgbox('温馨提示：',"删除失败");
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
},
backPage(){
this.$router.push({name:'applicationProfessionalTransfer'})
},
}
}



// WEBPACK FOOTER //
// ./src/components/myNoticeApply.vue